import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4b35c0fb&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./header.scss?vue&type=style&index=0&id=4b35c0fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b35c0fb",
  null
  
)

export default component.exports